export default __webpack_public_path__ + "static/media/criacaoDeEcommerce.9dadeafe.svg";